import React from 'react'
import { array, number, string } from 'prop-types'
import { FlexDatesCollapsibleContainer } from '@pcln/flex-dates'
import { Background, GridLayout } from './FlexDatesRoundTrip.styles'
import { generateCell, generatePriceMap, generatePriceThreshold } from './HelpersGrid'
import { PriceLegend } from './Legend'

/**
 * The Awesome Flex Dates Round Trip Grid Component
 */

export const FlexDatesRoundTripGrid = (props) => {
  const { dates, travelDate, returnDate, minimumRetailPrice } = props

  const priceThreshold = generatePriceThreshold({ dates, travelDate, returnDate, minimumRetailPrice })
  const priceMap = generatePriceMap({ dates, travelDate, returnDate, minimumRetailPrice })

  return (
    <FlexDatesCollapsibleContainer
      title='Flexible dates?'
      subTitle='Compare prices and save'
      mb={3}
      mx={[2, 2, 2, 2, 0]}
      data-testid='round-trip-grid'
    >
      <Background pt={2} pl={0} pb={2} pr={2} m={2} bg='white'>
        <GridLayout>{priceMap.map((day, i) => generateCell(day, i, priceThreshold, props))}</GridLayout>
        <PriceLegend priceThreshold={priceThreshold} />
      </Background>
    </FlexDatesCollapsibleContainer>
  )
}

// Proptypes
FlexDatesRoundTripGrid.propTypes = {
  dates: array,
  travelDate: string,
  returnDate: string,
  minimumRetailPrice: number,
  url: string,
}
